<template>
  <div class="production">
    <Title :title="title" />
    <div class="swiper" v-html="details.CONTENT"></div>
  </div>
</template>

<script>
import Title from '../../about/Title/Title.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Title
  },
  data() {
    return {
      title: {
        cn: '生产实力',
        en: 'production ability'
      },
      typeID: {
        en: '45',
        'zh-CN': '44'
      },
      details: {}
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    getID(){
      return this.typeID[this.lang]
    }
  },
  watch: {
    lang: 'fetchDate'
  },
  mounted(){
    this.fetchDate(this.lang)
  },
  methods: {
    fetchDate (val) {
      if (val) {
        let id=this.getID
        const url = `/php/singlepage.php?id=${id}`
        this.$$axios.get(url).then(res => {
          this.details = res.data
        })
      }
    }
  }
}
</script>

<style scoped>
.production{
    padding: 50px 100px;
    max-width: 1500px;
    margin: 0 auto;
}
.production .title{
  margin-bottom: 30px;
}
</style>


